var app = angular.module('directives.cardSecure', []);

require('./stylesheets/secure3d.sass');
require('./directives/secure3d.directive.js');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/cardSecure/index.js
 ** module id = 144
 ** module chunks = 1
 **/